export enum PlaceOfOccurrenceEnum {
	HOSPITAL = 1,
	OTHER_HEALTH_ESTABLISHMENT = 2,
	HOME = 3,
	PUBLIC_ROAD = 4,
	OTHERS = 5,
	IGNORED = 6,
}
